// frontend/src/services/tokenStorage.js
//
// Single source of truth for the session token in localStorage.
// The `tokenRefreshed` socket handler used to write the raw JWT here, while
// api.js and SocketContext expected JSON, which broke every HTTP call after a
// refresh. readToken() tolerates both formats so sessions created by the buggy
// build keep working after the upgrade.

const TOKEN_KEY = "token";

export const readToken = () => {
  const raw = localStorage.getItem(TOKEN_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === "string" ? parsed : null;
  } catch {
    // Legacy raw token written without JSON.stringify.
    return raw;
  }
};

export const writeToken = (token) => {
  if (!token) return;
  localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};
